import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ProfileMenu = ({ activePage, userId, isSocialUser: propIsSocialUser }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const [isSocialUserState, setIsSocialUserState] = useState(false);

  // Check if user is logged in via social provider
  useEffect(() => {
    const checkSocialUser = () => {
      const userStr = localStorage.getItem("user");
      if (userStr) {
        try {
          const user = JSON.parse(userStr);
          setIsSocialUserState(user?.provider === "google" || user?.provider === "apple");
        } catch (e) {
          console.error("Error parsing user data:", e);
        }
      }
    };
    checkSocialUser();
  }, []);

  // Use prop if provided, otherwise use state from localStorage
  const isSocialUser = propIsSocialUser !== undefined ? propIsSocialUser : isSocialUserState;

  const pathname = location.pathname.toLowerCase();
  const activeTab =
    activePage ||
    (pathname.includes("changepassword")
      ? "changepassword"
      : pathname.includes("useraddressinfo")
      ? "useraddressinfo"
      : pathname.includes("userorders")
      ? "userorders"
      : "profile");

  const handleSelectChange = (e) => {
    const selectedTab = e.target.value;
    if (selectedTab === "profile") {
      navigate(`/profile/${userId}`);
    } else if (selectedTab === "changepassword") {
      navigate(`/profile/${userId}/changepassword`);
    } else if (selectedTab === "useraddressinfo") {
      navigate(`/profile/${userId}/useraddressinfo`);
    } else if (selectedTab === "userorders") {
      navigate(`/profile/${userId}/userorders`);
    }
  };

  return (
    <>
      <section className="border-bottom">
        <div className="container-fluid">
          <div className="row" style={{ minHeight: "70px" }}>
            <div className="col-4 d-flex align-items-center">
              <p className="text-uppercase mt-3 mx-3">{t("NeedHelp")}</p>
            </div>

            {/* Mobilde Select Box */}
            <div className="col-8 d-flex align-items-stretch justify-content-end px-0 d-md-none">
              <select
                className="form-select"
                value={activeTab}
                onChange={handleSelectChange}
                style={{
                  fontSize: "14px",
                  padding: "10px",
                  border: "1px solid #ddd",
                  borderRadius: "5px",
                  width: "100%",
                }}
              >
                <option value="profile">{t("ProfileTab")}</option>
                {/* Hide Change Password for social login users */}
                {!isSocialUser && (
                  <option value="changepassword">{t("ChangePassword")}</option>
                )}
                <option value="useraddressinfo">{t("AddressTab")}</option>
                <option value="userorders">{t("OrdersTab")}</option>
              </select>
            </div>

            {/* Desktop ve Tablet için Orijinal Menü */}
            <div className="col-8 d-flex align-items-stretch justify-content-end px-0 d-none d-md-flex">
              <ul
                className="nav nav-tabs border-0"
                id="myTab"
                role="tablist"
                style={{ height: "100%" }}
              >
                {/* Profile Link */}
                <li
                  className="nav-item"
                  role="presentation"
                  style={{ height: "100%", width: "150px" }}
                >
                  <a
                    href={`/profile/${userId}`}
                    className={`nav-link rounded-0 fs-11 ${
                      activeTab === "profile"
                        ? "active headertargetbttomcolor border-end-0"
                        : "border-start border-bottom-0 border-end-0"
                    }`}
                    role="tab"
                    aria-selected={activeTab === "profile"}
                    style={{
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(`/profile/${userId}`);
                    }}
                  >
                    {t("ProfileTab")}
                  </a>
                </li>

                {/* Change Password Link - Hidden for social login users */}
                {!isSocialUser && (
                  <li
                    className="nav-item"
                    role="presentation"
                    style={{ height: "100%", width: "150px" }}
                  >
                    <a
                      href={`/profile/${userId}/changepassword`}
                      className={`nav-link rounded-0 fs-11 ${
                        activeTab === "changepassword"
                          ? "active headertargetbttomcolor border-end-0"
                          : "border-0 border-start"
                      }`}
                      role="tab"
                      aria-selected={activeTab === "changepassword"}
                      style={{
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        navigate(`/profile/${userId}/changepassword`);
                      }}
                    >
                      {t("ChangePassword")}
                    </a>
                  </li>
                )}

                {/* User Address Info Link */}
                <li
                  className="nav-item"
                  role="presentation"
                  style={{ height: "100%", width: "150px" }}
                >
                  <a
                    href={`/profile/${userId}/useraddressinfo`}
                    className={`nav-link rounded-0 fs-11 ${
                      activeTab === "useraddressinfo"
                        ? "active headertargetbttomcolor border-end-0"
                        : "border-0 border-start"
                    }`}
                    role="tab"
                    aria-selected={activeTab === "useraddressinfo"}
                    style={{
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(`/profile/${userId}/useraddressinfo`);
                    }}
                  >
                    {t("AddressTab")}
                  </a>
                </li>

                {/* User Orders Info Link */}
                <li
                  className="nav-item"
                  role="presentation"
                  style={{ height: "100%", width: "150px" }}
                >
                  <a
                    href={`/profile/${userId}/userorders`}
                    className={`nav-link rounded-0 fs-11 ${
                      activeTab === "userorders"
                        ? "active headertargetbttomcolor border-end-0"
                        : "border-0 border-start"
                    }`}
                    role="tab"
                    aria-selected={activeTab === "userorders"}
                    style={{
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(`/profile/${userId}/userorders`);
                    }}
                  >
                    {t("OrdersTab")}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ProfileMenu;
